import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';

import {TimerFacade} from '@app/core/facades/timer/timer-facade';

@Component({
  selector:        'timer',
  templateUrl:     './timer.component.html',
  styleUrls:       ['./timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimerComponent implements OnDestroy, OnInit {
  /** Input representing the ending date for counter */
  @Input() public date: Date;

  constructor(public readonly timerFacade: TimerFacade) {}

  /** Reset timer on destruction of component to avoid memory leaks.*/
  public ngOnDestroy(): void {
    this.timerFacade.resetTimer();
  }

  /** Initialize the counter from given date/time */
  public ngOnInit(): void {
    this.timerFacade.setTimer(this.date);
  }
}
